'use client';

import { useEffect } from 'react';

export default function InstagramRedirect() {
  useEffect(() => {
    window.location.href = 'https://www.instagram.com/dysteofficial';
  }, []);

  return (
    <div style={{ 
      height: '100vh', 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center',
      background: '#0a0012',
      color: '#b282de',
      fontFamily: 'system-ui'
    }}>
      <p>redirecting to instagram...</p>
    </div>
  );
}
